<template>
	<div class="notice">
		<router-link v-if="href && href.startsWith('/')" class="notice-content" :to="href">
			<slot></slot>
		</router-link>
		<div v-else class="notice-content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: [ 'href' ],
};
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.notice {
	margin: 16px 0 8px;
	position: relative;
	padding: 10px 16px 8px;
	border-radius: 6px;
	color: $color-fg-dim;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		background: $color-md;
		border-radius: 6px;
		transition: 1s all;
		z-index: 1;
	}

	&:hover::before {
		background: $color-md-bright;
		border-radius: 8px;
		transform: scale(1.01, 1.1);
	}

	> .notice-content {
		position: relative;
		z-index: 2;
		text-decoration: none;
	}
}
</style>